import * as React from "react";
import { SVGProps } from "react";

const Lisk = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 326" {...props}>
    <path
      fill="#04183d"
      d="m138.16 0-29.28 48.7 105.7 181.14L128.83 326s67.4-.4 67 0S276 235.43 276 235.43ZM99.71 66.66 0 236.23 78.57 326h29.55l43.2-50.28h-48L61 228.65l67.8-115.31Z"
    />
  </svg>
);

export default Lisk;
